<template>
    <div class="container-flud">
        <h4 v-if="loadingDrafts" class="status-line">Loading <i class="fa fa-spinner fa-spin"></i></h4>
        <table v-else-if="drafts.length > 0" class="table table-condensed">
            <thead>
                <tr>
                    <th v-for="header in ['Account', 'Creation Time', 'Number of Sample Groups', 'Total Number of Samples', 'Delete']">
                        <strong>{{ header }}</strong>
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(draft,index) in drafts">
                    <tr>
                        <td>
                            {{ draft.account_nbr }}
                        </td>
                        <td>
                            {{ draft.order_ts }}
                        </td>
                        <td>
                            {{ draft.sample_group_count }}
                        </td>
                        <td>
                            {{ draft.total_sample_count }}
                        </td>
                        <td>
                            <button type="button" class="btn btn-danger"
                                    @click="() => confirmDeleteDraft(draft.analysis_order_id, draft.account_nbr)">
                                <i class="fa fa-trash"></i>Delete
                            </button>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <h4 v-else class="status-line">No Drafts Found</h4>
    </div>
</template>

<style scoped lang="scss">
    .status-line {
        text-align: center;
    }
</style>

<script>

export default{
    props: ['user_id'],

    data: function() {
        return {
            drafts: [],
            loadingDrafts: true
        }
    },

    methods: {
        getAllDrafts() {
            this.drafts = [];
            this.loadingDrafts = true;
            this.$http.get(`/admin/users/profile/${this.user_id}/drafts`)
                .then(response => {
                    this.drafts = response.data;
                    this.loadingDrafts = false;
                });
        },

        deleteDraft(analysisOrderId) {
            this.loadingDrafts = true;
            this.$http.delete(`/admin/users/profile/${this.user_id}/drafts/${analysisOrderId}`)
                .then(response => {
                    this.getAllDrafts();
                });
        },

        confirmDeleteDraft(analysisOrderId, accountNum) {
            swal({
                title: "Delete Draft Order?",
                text: `Are you sure you want to delete submission order for account ${accountNum}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Delete",
                closeOnConfirm: true
            }, () => {
                this.deleteDraft(analysisOrderId);
            });
        }
    },

    mounted: function() {
        this.getAllDrafts();
    }
}
</script>



// WEBPACK FOOTER //
// submission-draft-table.vue?64fa22fc